import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "The Spark",
    body: [
      "Born and raised in Los Angeles, Phillip began programming at ten years old — long before computers became part of everyday life.",
      "Technology wasn't simply a subject he studied. It became the language through which he understood possibility.",
    ],
  },
  {
    n: "02",
    title: "The Experience",
    body: [
      "By thirteen, Phillip was already assisting with computer consulting work alongside his father.",
      "That early curiosity developed into a career spanning technology consulting, education, entrepreneurship, and work with organizations ranging from small businesses to Fortune 500 companies.",
      "Eventually, Phillip built his own consulting and technology education businesses — helping organizations and communities use technology more effectively.",
    ],
  },
  {
    n: "03",
    title: "The Mission",
    body: [
      "Phillip's greatest passion is helping people understand technology without feeling intimidated by it.",
      "For more than thirty years, he has taught youth, adults, professionals, educators, and executives from classrooms and corporate environments to conference stages around the world.",
      "Today his focus is helping organizations prepare their people for the next major technology shift: artificial intelligence.",
    ],
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
          The Story
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6 max-w-4xl">
          Technology has been part of Phillip Banks Sr.'s life since childhood.{" "}
          <span className="italic text-primary">Teaching it became his mission.</span>
        </motion.h2>

        <div className="mt-24 space-y-24 lg:space-y-32">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              data-testid={`about-chapter-${c.n}`}
              className={`grid grid-cols-1 md:grid-cols-12 gap-8 items-start ${i % 2 === 1 ? "md:pl-24" : ""}`}
            >
              <div className="md:col-span-3">
                <span className="font-display text-7xl lg:text-8xl text-outline select-none">{c.n}</span>
              </div>
              <div className="md:col-span-9 lg:col-span-7 border-l-2 border-primary/40 pl-8 lg:pl-12">
                <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight">{c.title}</h3>
                <div className="mt-6 space-y-5 text-base sm:text-lg leading-relaxed font-light text-foreground/80">
                  {c.body.map((p) => (
                    <p key={p.slice(0, 24)}>{p}</p>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
